import { getChartType } from '@/explore/components/visualisation/utils';
import {
  ChartType,
  Field,
  Visualisation,
  VisualisationOrientation,
  VisualisationViewOptions,
} from '@/explore/types';

export const setVisualisationOptions = (
  visualisation: Visualisation,
  viewOptions: VisualisationViewOptions,
) => ({
  ...visualisation,
  viewOptions,
});

export const getVisualisationOptions = (visualisation: Visualisation): VisualisationViewOptions => {
  return visualisation.viewOptions ?? {};
};

export const isVisualisationStacked = (
  visualisationOptions: VisualisationViewOptions,
  hasMoreThanOneSeries: boolean,
): boolean => hasMoreThanOneSeries && visualisationOptions.stacked === true;

export const getVisualisationShowTotals = (
  visualisationOptions: VisualisationViewOptions,
): boolean => visualisationOptions.showTotals === true;

export const getVisualisationOrientation = (
  visualisation: Visualisation,
  fields: Field[],
): VisualisationOrientation =>
  visualisation.viewOptions?.orientation ??
  getVisualisationDefaultOrientation(visualisation, fields);

const getVisualisationDefaultOrientation = (
  visualisation: Visualisation,
  fields: Field[],
): VisualisationOrientation => {
  switch (getChartType(visualisation, fields)) {
    case 'bar':
      return 'horizontal';
    default:
      return 'vertical';
  }
};

export const getVisualisationDefaultChartType = (
  visualisation: Visualisation,
  fields: Field[],
): ChartType => {
  switch (getChartType(visualisation, fields)) {
    case 'bar':
      return 'bar';
    default:
      return 'area';
  }
};
